import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import type { ControllerFlowAPI, ISeo } from '@wix/yoshi-flow-editor';
import type { PopulatedMenu, PopulatedSection } from 'root/apiTypes';
import type { MenuOrder } from 'root/components/Menus/Settings/Tabs/MenusTab/MenusSettingsParams';
import { MENUS_EXTENDED_FIELDS_NAME_SPACE } from 'root/consts';

export const getMenusSEOData = ({
  activeMenu,
  pageUrl,
  multilingual,
  menusDisplayOrder,
  firstMenu,
}: {
  activeMenu: PopulatedMenu;
  pageUrl: string;
  multilingual: ControllerFlowAPI['environment']['multilingual'];
  menusDisplayOrder?: MenuOrder[];
  firstMenu?: PopulatedMenu;
}) => {
  const menuItems = activeMenu.sections.flatMap((section: PopulatedSection) => section.items);
  const isMainMenu = menusDisplayOrder?.[0].id === activeMenu.id || firstMenu?.id === activeMenu.id;

  return {
    menu: {
      ...activeMenu,
      url: pageUrl,
      isMainMenu,
    },
    items: menuItems,
    translatedPages: multilingual,
  };
};

export const sendSEOData = ({
  baseUrl,
  siteUrl,
  isCurrentPageMenusDefaultPage,
  multilingual,
  menusDisplayOrder,
  menus,
  seo,
  activeMenu,
}: {
  baseUrl: string;
  siteUrl: string;
  isCurrentPageMenusDefaultPage: boolean;
  multilingual: ControllerFlowAPI['environment']['multilingual'];
  menusDisplayOrder?: MenuOrder[];
  menus: PopulatedMenu[];
  seo: ISeo;
  activeMenu: PopulatedMenu;
}) => {
  const pageBaseUrl = baseUrl;
  const urlQueryParam = `?menu=${encodeURIComponent(activeMenu.urlQueryParam ?? '')}`;
  const fullPageUrl = pageBaseUrl + siteUrl + urlQueryParam;
  const itemData = getMenusSEOData({
    activeMenu,
    pageUrl: fullPageUrl,
    multilingual,
    menusDisplayOrder,
    firstMenu: menus[0],
  });

  seo.renderSEOTags({
    itemType: isCurrentPageMenusDefaultPage ? ITEM_TYPES.RESTAURANTS_MENU_PAGE : ITEM_TYPES.RESTAURANTS_MENU_COMPONENT,
    itemData,
    seoData: activeMenu?.extendedFields?.namespaces?.[MENUS_EXTENDED_FIELDS_NAME_SPACE]?.seoData || {},
  });
};
